import useActivation from "./useActivation";

// eslint-disable-next-line prettier/prettier, no-empty -- https://github.com/babel/babel/issues/15156
{}
/**
 * A factory function used to create a plugin for the point cuts package that activates experiments with Optimizely
 * @function
 * @inner
 * @memberof module:asos-web-toggle-point-optimizely
 * @param {external:HostApplication.sdkInstanceProvider} sdkInstanceProvider SDK instance provider
 * @param {function} getAudience A function to get the audience that produced the matched decisions when activating, which is called honouring the rules of hooks.
 * @returns {module:asos-web-toggle-point-cuts~plugin} FeaturesActivation asos-web-toggle-point-cuts plugin
 * @example
 * const plugin = pointCutPluginFactory({ sdkInstanceProvider, audience });
 */
const pointCutPluginFactory = ({ sdkInstanceProvider, getAudience }) => {
  const useHook = ({ matchedFeatures }) => {
    const audience = getAudience();
    return useActivation({ audience, sdkInstanceProvider, matchedFeatures });
  };
  return {
    name: "FeaturesActivation",
    onCodeSelected: useHook
  };
};

export default pointCutPluginFactory;
